// FLAGS: none
// React Query cache-key vocabulary plus the translated option lists for the session-notes dropdowns. The
// larger constant set (roles, api paths, language codes) lives in src/constants.ts, not here.
import { TFunction } from "i18next";
import { HELP_NEEDED_VALUES, NETWORK_PROVIDER_VALUES } from "@src/constants";

export const queryIdentifiers = {
  psychologists: "psychologists",
  psychologistManagement: "psychologist-management",
  consults: "consults",
  consult: "consult",
  reassignPsychologist: "reassign-psychologist",
  makePsychologist: "make-psychologist",
  employee: "employee",
  openupEmployees: "openup-employees",
  sessions: "sessions",
  allSessions: "all-sessions",
  profile: "profile",
  googleCalendar: "google-calendar",
  getCalendar: "get-calendars",
  registerCalendar: "register-calendar",
  clients: "clients",
  mySessions: "my-sessions",
  myClients: "clients/my",
  questionListAnswers: "question-list-answers",
  themes: "themes",
  dossierNote: "dossier-note",
  employers: "employers",
  notes: "notes",
  externalQuestionnaires: "external-questionnaires",
  scheduler: "scheduler",
  availableTimeSlots: "scheduler/time-slots/available",
  cancel: "cancel",
  reschedule: "reschedule",
  tags: "tags",
  notifications: "notifications",
  timezones: "scheduler/timezones",
  topics: "Topics",
  bookConsultWithClient: "book-consult-with-client",
  unlock: "unlock",
  exprtDetails: "expert-details",
  sessionNotes: "session-notes",
  attachments: "attachments",
};

export const getHelpNeededOptions = (
  t: TFunction<"translation", undefined>,
) => {
  return [
    {
      value: HELP_NEEDED_VALUES.TRUE,
      label: t("Consults.SessionDetails.HelpClient.canSupportWithinOpenUp"),
    },
    {
      value: HELP_NEEDED_VALUES.REFER_TO_OPENUP_NETWORK,
      label: t("Consults.SessionDetails.HelpClient.referToOpenUpNetwork"),
    },
    {
      value: HELP_NEEDED_VALUES.NO_REFER_TO_OTHER_PROVIDER,
      label: t("Consults.SessionDetails.HelpClient.referToOutsideProvider"),
    },
    {
      value: HELP_NEEDED_VALUES.OTHER,
      label: t("Consults.SessionDetails.HelpClient.otherReason"),
    },
  ];
};

export const getOpenUpNetworkProviders = (
  t: TFunction<"translation", undefined>,
) => {
  return [
    {
      value: NETWORK_PROVIDER_VALUES.PSYNED,
      label: t("Consults.SessionDetails.HelpClient.NetworkProvider.psyNed"),
    },
    {
      value: NETWORK_PROVIDER_VALUES.IPRACTICE,
      label: t("Consults.SessionDetails.HelpClient.NetworkProvider.iPractice"),
    },
    {
      value: NETWORK_PROVIDER_VALUES.KIRINUS_HEALTH,
      label: t(
        "Consults.SessionDetails.HelpClient.NetworkProvider.kirinusHealth",
      ),
    },
    {
      value: NETWORK_PROVIDER_VALUES.ONEBRIGHT,
      label: t("Consults.SessionDetails.HelpClient.NetworkProvider.oneBright"),
    },
  ];
};

export const getFinancialWellbeingHelpNeededOptions = (
  t: TFunction<"translation", undefined>,
) => {
  return [
    {
      value: HELP_NEEDED_VALUES.TRUE,
      label: t("Consults.SessionDetails.HelpClient.canSupportWithinOpenUp"),
    },
    {
      value: HELP_NEEDED_VALUES.NO_REFER_TO_OTHER_PROVIDER,
      label: t("Consults.SessionDetails.HelpClient.referToOutsideProvider"),
    },
    {
      value: HELP_NEEDED_VALUES.OTHER,
      label: t("Consults.SessionDetails.HelpClient.otherReason"),
    },
  ];
};

export const getNextStepsForSessionNotes = (
  t: TFunction<"translation", undefined>,
) => {
  return [
    {
      value: "weeks",
      label: t("Consults.SessionDetails.NextSteps.Weeks"),
    },
    {
      value: "months",
      label: t("Consults.SessionDetails.NextSteps.Months"),
    },
    {
      value: "break",
      label: t("Consults.SessionDetails.NextSteps.Break"),
    },
  ];
};

export const SESSION_TYPE = {
  GENERAL: "general",
  MINDFULNESS: "mindfulness",
  MEDICAL: "medical",
};

export const THEME_KEY = {
  CONFIDENCE: "Confidence",
  STRESS: "Stress",
  WORK: "Work",
  PURPOSE: "Purpose",
  RELATIONSHIPS: "Relationships",
  HEALTH: "Health",
  SLEEP: "Sleep",
  MINDFULNESS: "Mindfulness",
};

export const MEDICAL_THEME_KEY = {
  BREATHING: "Breathing",
  DAILY_ENERGY: "DailyEnergy",
  INTOXICATION: "Intoxications",
  MENTAL_HEALTH: "MentalHealth",
  NUTRITION: "Nutrition",
  PHYSICAL_ACTIVITY: "PhysicalActivity",
  SLEEP_SATISFACTION: "SleepSatisfaction",
};

export const SESSION_NOTES_SECTIONS = {
  REASON_BOOK: "reasonBook",
  SESSION_DISCUSSED: "sessionDiscussed",
  HELP_NEEDED: "helpNeeded",
  PROVIDER: "provider",
  PROVIDER_NAME: "providerName",
  NEXT_STEPS: "nextSteps",
  CA_OTHER_DESCRIPTION: "caOtherDescription",
};
export type SessionNotesSection =
  (typeof SESSION_NOTES_SECTIONS)[keyof typeof SESSION_NOTES_SECTIONS];

export const IT_SUPPORT_SLACK_URL =
  "https://openup-nl.slack.com/archives/C073HBV20KH";
export const IT_SUPPORT_EMAIL = "techquestions@openup.com";
export const USER_LOCKED_OUT_ERROR = "RegisterView.UserLockedOut";
